exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select {\n  padding-top: 5px !important;\n  padding-bottom: 5px !important;\n  padding-left: 12px !important;\n}\n", ""]);

// exports
